<app-section-header surtitle="Événements" title="Événements"></app-section-header>

<div class="event-content">
    <div class="event-item" *ngFor="let event of events">
        <div class="event-date">
            <mat-icon>event</mat-icon>
            <span>{{ event.date }}</span>
        </div>
        <div class="event-description">{{ event.description }}</div>
    </div>
</div>
